// API =>
import { AxiosError } from 'axios';
import backEnd from "../../services/Api";

// Type =>
import { ProductDetailResultType } from './showProductType';

export const ProductDetailReceivre = async (productId: number): Promise<ProductDetailResultType> => {
    try {
        const response = await backEnd.get(`products/get-product-Detail/${productId}/`);
        return { success: true, data: response.data, message: "" };
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response?.status;

            const messages: Record<number, string> = {
                400: "درخواست نامعتبر است. لطفاً اطلاعات را بررسی کنید.",
                404: "محصول مورد نظر پیدا نشد.",
                429: "تعداد درخواست‌ها زیاد است. لطفاً چند لحظه صبر کنید.",
                500: "خطای سرور. لطفاً بعداً دوباره امتحان کنید.",
                503: "سرور در دسترس نیست. لطفاً بعداً امتحان کنید.",
            };

            const message = status
                ? messages[status] ?? `خطای ناشناخته (کد: ${status})`
                : "اتصال به سرور برقرار نشد. اینترنت خود را بررسی کنید.";

            return { success: false, data: null, message };
        }

        return { success: false, data: null, message: "یک خطای غیرمنتظره رخ داد." };
    }
};
